import { useScrollLock } from '@/hooks/useScrollLock';

/**
 * Drop this inside an overlay's scrim and the page behind it stops scrolling.
 *
 * It renders nothing. The point of it being a component rather than a hook call in the
 * modal's own body is that the scrim only exists in the DOM while the overlay is open, so
 * the lock cannot get out of step with what the user can see. A hook at the top of a page
 * component would have to re-derive "is a modal open?" from state — and if that guess were
 * ever wrong the page would be frozen with no modal on screen, which is far worse than the
 * bug it fixes.
 *
 * Usage — note the overlay's own classes follow the pattern `modal-viewport.guard.test.ts`
 * pins (`items-start` + `overflow-y-auto`, with `my-auto` on the panel), so a tall dialog
 * scrolls instead of putting its buttons off-screen:
 *
 *   <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4">
 *     <ScrollLock />
 *     <div className="my-auto …">…panel…</div>
 *   </div>
 */
export function ScrollLock() {
  useScrollLock();
  return null;
}
